import {
  ADMIN_VIEW_TO_FEATURE,
  ROUTE_PATH_TO_FEATURE,
  canAccessAdminShellFromFeatures,
  ALL_STAFF_FEATURE_IDS
} from '../config/staffFeatures';

export function isFullAdminFromStorage() {
  if (localStorage.getItem('isFullAdmin') === 'true') return true;
  return localStorage.getItem('isAdmin') === 'true';
}

/** Personal del panel (no admin completo): sin chat IA ni modal de suscripción a clientes. */
export function isStaffOrViewerFromStorage() {
  if (isFullAdminFromStorage()) return false;
  if (localStorage.getItem('isAuthenticated') !== 'true') return false;
  const role = localStorage.getItem('userRole');
  return role === 'staff' || role === 'viewer';
}

export function isViewerFromStorage() {
  if (isFullAdminFromStorage()) return false;
  if (localStorage.getItem('isAuthenticated') !== 'true') return false;
  return localStorage.getItem('userRole') === 'viewer';
}

export function getStaffPermissionsFromStorage() {
  try {
    const raw = localStorage.getItem('staffPermissions');
    if (!raw) return [];
    const p = JSON.parse(raw);
    return Array.isArray(p) ? p.filter((x) => typeof x === 'string') : [];
  } catch {
    return [];
  }
}

export function hasStaffFeature(featureId) {
  if (isFullAdminFromStorage()) return true;
  return getStaffPermissionsFromStorage().includes(featureId);
}

export function canAccessAdminShell() {
  return canAccessAdminShellFromFeatures(isFullAdminFromStorage(), getStaffPermissionsFromStorage());
}

/**
 * Rutas de herramientas sueltas (no /admin).
 * path: pathname tipo /gestion-stock (sin query).
 */
export function canAccessStaffPath(pathname) {
  if (isFullAdminFromStorage()) return true;
  const feature = ROUTE_PATH_TO_FEATURE[pathname];
  if (!feature) return false;
  return hasStaffFeature(feature);
}

export function hasStaffFeatureForAdminView(viewKey) {
  const fid = ADMIN_VIEW_TO_FEATURE[viewKey];
  if (!fid) return false;
  return hasStaffFeature(fid);
}

export function filterValidStaffFeatureIds(ids) {
  const allowed = new Set(ALL_STAFF_FEATURE_IDS);
  if (!Array.isArray(ids)) return [];
  return [...new Set(ids.filter((id) => typeof id === 'string' && allowed.has(id)))];
}
